import React, { useState, useContext } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import ArchivosService from '../../axios_services/archivos.service';
import { AppContext } from '../../application/provider';
import { Upload } from 'lucide-react';
import './ModalPropuestaSolicitud.css';
import './ModalEditProspectos.css';
import './ModalInduccion.css';

const ModalInduccion = ({ closeModal, images, refreshImages, onUploadSuccess }) => {
  const [globalState] = useContext(AppContext);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = (e) => {
    const list = e.target.files;
    if (list && list.length > 0) {
      setSelectedFiles(Array.from(list));
    } else {
      setSelectedFiles([]);
    }
  };

  const handleUpload = async () => {
    if (!selectedFiles.length) {
      alert('Seleccione al menos una imagen');
      return;
    }

    setIsUploading(true);
    const cantidad = selectedFiles.length;
    try {
      let nextOrder =
        images.length > 0 ? Math.max(...images.map((i) => Number(i.origen_id) || 0)) + 1 : 1;

      for (let i = 0; i < selectedFiles.length; i += 1) {
        const file = selectedFiles[i];
        const res = await ArchivosService.guardarImagenInduccion(
          file,
          nextOrder,
          globalState.user.usuario_id
        );
        if (!res.success) {
          alert(res.message || `Error al subir la imagen ${i + 1}`);
          setIsUploading(false);
          refreshImages();
          return;
        }
        nextOrder += 1;
      }

      setSelectedFiles([]);
      refreshImages();
      closeModal();
      if (typeof onUploadSuccess === 'function') {
        onUploadSuccess(cantidad);
      }
    } catch (error) {
      console.error(error);
      alert('Ocurrió un error al subir las imágenes');
      refreshImages();
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <Modal
      isOpen
      backdrop
      size="lg"
      className="modal-dialog-centered"
      contentClassName="bg-white"
      style={{ backgroundColor: '#ffffff' }}
    >
      <ModalHeader className="modal-header">
        <div className="titulo">
          <h1>Subir imágenes — Inducción Negocios</h1>
          <Button className="close-btn" onClick={closeModal}>
            X
          </Button>
        </div>
      </ModalHeader>

      <div className="modal-body-footer">
        <ModalBody>
          <div className="fila" style={{ marginTop: 0 }}>
            <div style={{ fontWeight: 'bold', marginBottom: 4 }}>Agregar imágenes al manual</div>
            <label className="induccion-upload-dropzone">
              <input
                type="file"
                accept="image/jpeg,image/png,image/jpg,image/webp"
                multiple
                className="induccion-upload-file-input"
                onChange={handleFileChange}
              />
              <span className="induccion-upload-dropzone-visual">
                <span className="induccion-upload-dropzone-icon">
                  <Upload size={36} strokeWidth={1.5} />
                </span>
                <span className="induccion-upload-dropzone-text">Haga clic para elegir archivos</span>
                <span className="induccion-upload-dropzone-hint">JPEG, PNG, JPG o WebP</span>
              </span>
            </label>
            {selectedFiles.length > 0 && (
              <p className="induccion-upload-selected">
                {selectedFiles.length === 1
                  ? '1 imagen seleccionada'
                  : `${selectedFiles.length} imágenes seleccionadas`}
              </p>
            )}
          </div>
        </ModalBody>

        <ModalFooter style={{ display: 'flex', justifyContent: 'flex-end', width: '95%' }}>
          <Button color="success" onClick={handleUpload} disabled={!selectedFiles.length || isUploading}>
            {isUploading ? 'Subiendo...' : 'Subir todas'}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

export default ModalInduccion;
